import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import './../Resources/css/block_imageInsert.css';

const ImageInsert = (props) => {

    const [blockName, setBlockName] = useState("");
    const [id] = useState("id-" + props.addClass);
    const [addClass] = useState("imageInsert " + props.addClass);
    const [addClassInner] = useState("imageInsertInner");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Fragment>

            <div className="test d-none d-md-block">

                <div className={addClass}>
                    <div className={addClassInner}>
                    </div>
                </div>

            </div>

            <div id={id} className="d-md-none">
            </div>

        </Fragment>
    );
}
export default ImageInsert;

